<div class="help-floating-panel" 
     *ngIf="isOpen" 
     [class.show]="isOpen && currentContent"
     [style.transform]="'translate(' + position.x + 'px, ' + position.y + 'px)'"
     [style.width.px]="isMinimized ? minimizedSize.width : size.width"
     [style.height.px]="isMinimized ? minimizedSize.height : size.height"
     [class.minimized]="isMinimized"
     [class.dragging]="isDragging"
     [class.resizing]="isResizing"
     style="position: fixed; z-index: 9999;">
  
  <!-- Header (draggable) -->
  <div class="help-panel-header"
       (mousedown)="startDrag($event)"
       [class.dragging]="isDragging"
       [attr.role]="isMinimized ? 'button' : null"
       [attr.tabindex]="isMinimized ? 0 : null"
       [attr.aria-label]="isMinimized ? 'Expand: ' + (currentContent?.title || '') : null"
       (keydown.enter)="isMinimized && toggleMinimize()">
    <div class="help-panel-title">
      <ng-container *ngIf="currentContent">
        <!-- Minimized: one line, the whole bar expands on click -->
        <ng-container *ngIf="isMinimized">
          <h3>{{ currentContent.title }}</h3>
          <span class="help-steps-count">
            {{ currentContent.instructions.length }} {{ currentContent.instructions.length === 1 ? 'step' : 'steps' }}
          </span>
        </ng-container>
        <div class="help-title-text" *ngIf="!isMinimized">
          <span class="help-eyebrow">What to do</span>
          <h3>{{ currentContent.title }}</h3>
        </div>
      </ng-container>
    </div>
    <div class="header-controls">
      <button class="control-button minimize-button" *ngIf="!isMinimized"
              (click)="toggleMinimize()"
              title="Minimize"
              aria-label="Minimize">
        <mat-icon>remove</mat-icon>
      </button>
      <button class="control-button maximize-button" *ngIf="isMinimized"
              (click)="toggleMinimize()"
              title="Expand"
              aria-label="Expand">
        <mat-icon>open_in_full</mat-icon>
      </button>
      <button class="control-button close-button"
              (click)="closeModal()"
              title="Close"
              aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Resize handles -->
  <div class="resize-handles" *ngIf="!isMinimized">
    <div class="resize-handle resize-handle-n" (mousedown)="startResize($event, 'n')"></div>
    <div class="resize-handle resize-handle-s" (mousedown)="startResize($event, 's')"></div>
    <div class="resize-handle resize-handle-e" (mousedown)="startResize($event, 'e')"></div>
    <div class="resize-handle resize-handle-w" (mousedown)="startResize($event, 'w')"></div>
    <div class="resize-handle resize-handle-ne" (mousedown)="startResize($event, 'ne')"></div>
    <div class="resize-handle resize-handle-nw" (mousedown)="startResize($event, 'nw')"></div>
    <div class="resize-handle resize-handle-se" (mousedown)="startResize($event, 'se')"></div>
    <div class="resize-handle resize-handle-sw" (mousedown)="startResize($event, 'sw')"></div>
  </div>

  <!-- Content (collapsible) -->
  <div class="help-panel-content" *ngIf="!isMinimized && currentContent" 
       [style.max-height.px]="size.height - 120">
    
    <div class="instructions-view">
      <div class="instructions-section">
        <ol class="instructions-list">
          <li *ngFor="let instruction of currentContent.instructions">
            <div class="instruction-content">
              <span class="instruction-text">{{ instruction.text }}</span>
            </div>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="help-panel-footer" *ngIf="!isMinimized">
    <button class="btn btn-secondary" (click)="closeModal()">
      Close
    </button>
  </div>
</div>